import { BASE_API_URL } from "../layouts-upload-modal"
import modalString from "../styles/_minified/modal.css"
import cssString from "../styles/_minified/layout-errors.css"
import { PartData } from "../types/types"
import { createChevronLeftIcon, createCloseIcon, createInfoIcon, createModal, createRotateIcon } from "../utils/createElemets"
import { LayoutsUploadModal } from "./layouts-upload-modal"
import { LayoutsViewer } from "./layouts-viewer"

customElements.define(
    "layout-errors-modal",
    class extends HTMLElement {
        static observedAttributes = ["part-data", "index"]

        #partData?: PartData
        #layoutIndex: number
        #modal: HTMLDivElement
        #container: HTMLDivElement

        constructor() {
            super()

            this.#layoutIndex = 0
            this.#modal = document.createElement('div')
            this.#container = document.createElement('div')
            this.#container.onclick = e => {
                e.stopPropagation()
            }
            this.#modal.classList.add('layout-errors-container')
            this.#modal.onclick = e => {
                e.stopPropagation()
                this.#modal.classList.remove('visible')
                setTimeout(() => this.remove(), 300)
            }
        }

        connectedCallback() {
            if (!partsData) return

            const shadow = this.attachShadow({ mode: "open" })

            const sheet = new CSSStyleSheet()
            sheet.replaceSync(cssString + modalString)
            shadow.adoptedStyleSheets = [sheet]

            this.#modal.append(this.#container)
            setTimeout(() => this.#modal.classList.add('visible'))
            // ----------

            shadow.append(this.#modal)
        }

        get #index() {
            return this.#layoutIndex
        }

        set #index(number) {
            this.#layoutIndex = number
            if (!this.#partData) return

            const layoutState = layoutsState[this.#partData.id][this.#index]
            if (!layoutState || !layoutState.checkResData) return

            const checkDataResult = Object.values(layoutState.checkResData.result)[0]
            const errors = Object.values(checkDataResult.errors)[0]

            // ----------

            const title = document.createElement('div')
            title.classList.add('title')

            const previewImg = new Image()
            previewImg.src = BASE_API_URL + checkDataResult.preview
            previewImg.alt = 'layout-preview'
            previewImg.classList.add('preview-img')

            const h3 = document.createElement('h3')
            h3.textContent = layoutState.uploadResData.original_name

            const layoutTitle = document.createElement('span')
            layoutTitle.textContent = this.#partData.name

            const info = document.createElement('span')
            info.textContent = 'Исправьте замечания прежде чем загружать в макет'

            const btnContainer = document.createElement('div')
            btnContainer.classList.add('btn-container')

            const replaceLayoutBtn = document.createElement('button')
            replaceLayoutBtn.type = 'button'
            replaceLayoutBtn.textContent = 'Заменить макет'
            replaceLayoutBtn.onclick = () => createModal({
                title: 'Вы уверены что хотите заменить?',
                subTitle: 'Вы вернетесь в режим проверки и загрузки макетов, этот макет будет удален',
                submitText: 'Да, заменить',
                cancelText: 'Отменить',
                action: () => {
                    if (!this.#partData) return

                    let temp = layoutsState[this.#partData.id].slice()
                    temp[this.#index] = null
                    layoutsState[this.#partData.id] = temp

                    if (layoutsViewerModal)
                        (layoutsViewerModal as LayoutsViewer).closeModal()

                    if ((layoutsUploadModal as LayoutsUploadModal).step !== 1)
                        (layoutsUploadModal as LayoutsUploadModal).step = 1

                    this.#modal.classList.remove('visible')
                    setTimeout(() => this.remove(), 300)
                }
            }, this.shadowRoot)
            replaceLayoutBtn.prepend(createRotateIcon())

            btnContainer.append(replaceLayoutBtn)

            title.append(previewImg, h3, layoutTitle, info, btnContainer)

            // ----------

            const table = document.createElement('div')
            table.classList.add('table')

            const thead = document.createElement('div')
            thead.classList.add('thead')

            const params = ['Параметр', 'Требования', 'В макете']
            params.forEach(param => {
                const theadParam = document.createElement('div')
                theadParam.textContent = param
                thead.append(theadParam)
            })

            const tbody = document.createElement('div')
            errors.forEach(error => {

                const tr = document.createElement('div')
                tr.classList.add('tr')
                if (error.actionId === 1)
                    tr.classList.add('hidden')

                const label = document.createElement('div')
                label.textContent = error.label
                if (error.actionId === 2)
                    label.append(createInfoIcon('fatal'))
                else
                    label.append(createInfoIcon('ok'))
                label.onclick = e => tr.classList.toggle('hidden')

                const requireValue = document.createElement('div')
                requireValue.textContent = error.requireValue
                const requireValueSpan = document.createElement('span')
                requireValueSpan.textContent = 'Требования'
                requireValue.prepend(requireValueSpan)

                const value = document.createElement('div')
                value.textContent = error.value

                if (error.actionId === 2)
                    value.append(createInfoIcon('fatal'))

                const valueSpan = document.createElement('span')
                valueSpan.textContent = 'В макете'
                value.prepend(valueSpan)

                tr.append(label, requireValue, value, createChevronLeftIcon())
                tbody.append(tr)
            })
            tbody.classList.add('tbody')

            table.append(thead, tbody)

            const closeBtn = document.createElement('button')
            closeBtn.classList.add('close')
            closeBtn.append(createCloseIcon('var(--gray-800, #9C4221)'))

            const closeBtnSpan = document.createElement('span')
            closeBtnSpan.textContent = 'К файлам'
            closeBtnSpan.prepend(createChevronLeftIcon())
            closeBtn.append(closeBtnSpan)

            closeBtn.onclick = () => {
                this.#modal.classList.remove('visible')
                setTimeout(() => this.remove(), 300)
            }

            this.#container.append(title, table, closeBtn)
        }

        attributeChangedCallback(name: string, oldValue: string, newValue: string) {
            switch (name) {
                case 'part-data':
                    if (newValue)
                        this.#partData = partsData.find(part => part.id === newValue)
                    break

                case 'index':
                    if (newValue)
                        this.#index = +newValue
                    break

                default:
                    break
            }
        }
    })